import React from 'react';

const XBoxContainer = () => {
    return (
        <section>
            <div className="x-box-container">
                <div className="x-box-container-text">
                    <h2>Xbox Game Pass Ultimate</h2>
                    <p>Xbox Live Gold and over 100 high-quality console and PC games. Play together with friends and discover your next favourite game.</p>
                    <button className="xbox-btn">
                        <a href="https://www.microsoft.com/en-in/p/xbox-game-pass-ultimate/cfq7ttc0khs0?icid=mscom_marcom_MPH1a_GamePassUltimate">
                            <span>Join now </span> <i class="fa fa-angle-right"></i>
                        </a>
                    </button>
                </div>
            </div>
        </section>
    )
}

export default XBoxContainer;